module.exports = __webpack_public_path__ + "img/British.8efabdc4.svg";